module.exports = __webpack_public_path__ + "images/interview-Starbucks-2.svg";